import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-reporting',
    templateUrl: './reporting.component.html',
    styleUrls: ['./reporting.component.scss'],
    standalone: false
})
export class WorkshopReportingComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
